//import * as firebase from "firebase";

import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/auth';

import { FirebaseConfig } from "../config/keys";
firebase.initializeApp(FirebaseConfig);
const settings = {timestampsInSnapshots: true};
//const databaseRef = firebase.database().ref();
export const dbFirestore = firebase.firestore();
dbFirestore.settings(settings);

//REALES
export const usuarioRef = dbFirestore.collection("usuarios");
export const pedidosRef = dbFirestore.collection("pedidos");
export const pedidosContRef = dbFirestore.collection("pedidos_cont");
export const categoriasRef = dbFirestore.collection("categorias");
export const rubrosRef = dbFirestore.collection("rubros");
export const productosRef = dbFirestore.collection("productos")
export const enviometodosRef = dbFirestore.collection("envio_metodos")

export const refStorageTemp = firebase.storage().ref('/temp');
export const refProdsImgs = firebase.storage().ref('/productos');
export const refCustomImgs = firebase.storage().ref('/custom');
/*
//TESTS
export const usuarioRef = dbFirestore.collection("usuarios");
export const pedidosRef = dbFirestore.collection("test").doc("1").collection("pedidos");
export const pedidosContRef = dbFirestore.collection("test").doc("1").collection("pedidos_cont");
export const categoriasRef = dbFirestore.collection("test").doc("1").collection("categorias");
export const rubrosRef = dbFirestore.collection("test").doc("1").collection("rubros");
export const productosRef = dbFirestore.collection("test").doc("1").collection("productos");
export const enviometodosRef = dbFirestore.collection("test").doc("1").collection("envio_metodos");

export const refStorageTemp = firebase.storage().ref('/temp_test');
export const refProdsImgs = firebase.storage().ref('/productos_test');
export const refCustomImgs = firebase.storage().ref('/custom_test');
*/
export const authRef = firebase.auth();

//export const todosRef = databaseRef.child("todos");
//export const provider = new firebase.auth.GoogleAuthProvider();


// WEBPACK FOOTER //
// ./src/config/firebase.js